var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { TextField } from "@gemini/ui";
import { Controller } from "react-hook-form";
import { phoneNumberInputTestId } from "./constants";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { useIsPhoneNumberValidation } from "../../hooks/useIsPhoneNumberValidation";
import { PhoneNumberE164Input } from "./PhoneNumberE164Input";
export const PhoneNumberInput = ({ control, required }) => {
    const { t } = useI18n();
    const isPreviewMode = useIsPreviewMode();
    const isPhoneNumberValidationEnabled = useIsPhoneNumberValidation();
    return isPhoneNumberValidationEnabled ? (_jsx(PhoneNumberE164Input, { control: control, required: required })) : (_jsx(Controller, { name: "phoneNumber", control: control, defaultValue: "", render: (_a) => {
            var _b = _a.field, { onChange, value } = _b, field = __rest(_b, ["onChange", "value"]), { fieldState: { error } } = _a;
            return (_jsx(TextField, Object.assign({}, field, { type: "tel", inputMode: "tel", isFullWidth: true, testId: phoneNumberInputTestId, label: t("contact.form.phone"), placeholder: t("contact.form.phone_placeholder"), error: error === null || error === void 0 ? void 0 : error.message, hasNecessityIndicator: required, value: value, onChange: (event) => {
                    const sanitizedValue = event.replace(/(?!^\+)[^\d]/g, "");
                    if (sanitizedValue.length > 15) {
                        return;
                    }
                    onChange(sanitizedValue);
                }, isDisabled: isPreviewMode })));
        } }));
};
